
import axios from 'axios'
import store from '../store'
var ENVIRONMENT = ((process.env.VUE_APP_API_MODE != undefined) ? process.env.VUE_APP_API_MODE: 'development') == 'development' ;
// const baseURL = 'http://localhost:3002/_api';
const baseURL = ENVIRONMENT? 'https://qat-api.thietbi.com/_api' : (process.env.VUE_APP_API_URL == undefined ? 'https://qat-api.thietbi.com/_api' : process.env.VUE_APP_API_URL);
const accessToken = (store.getters.token != null && store.getters.token != '') ? store.getters.token: (ENVIRONMENT || process.env.VUE_APP_API_TOKEN == undefined ? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiRW5nbWEiLCJzZXJlY3QiOiJmOTBkNjg1OS1mNWY2LTQwMWYtOTRlZi00MGQ4NzBmNzljOGQiLCJWZXJpb24iOiIxLjAuMCIsImlhdCI6MTYxNDEzNjEyNn0.DwI91rmrsrbRyNYuqnJKsiO5ifQBbes2aEnNiuayhDs' : process.env.VUE_APP_API_TOKEN);
export default axios.create({
  baseURL,
  headers: {
    "Content-type": "application/json",
    'Authorization': 'Bearer ' + accessToken
  },
  json: true
});
